import { IEdgeDocument } from '@models/edge/edge-document';
import { Entity } from '@models/companies/entity';
import { SecurityChange } from '../documents/security-change';
import { CorporateHolderModel, IndividualHolderModel } from '../shares/security-registry-record';
import { SecurityTransaction } from './security-transaction';

export class EntitySecurityTransfer<TEntity extends Entity> extends SecurityChange<TEntity> implements IEdgeDocument {
  transferFrom: SecurityTransactionFrom;
  transferTo: SecurityTransactionTo;
  securityHoldersTo: (IndividualHolderModel | CorporateHolderModel)[];

  constructor(data: Partial<EntitySecurityTransfer<TEntity>> = {}) {
    super(data);

    this.transferFrom = new SecurityTransactionFrom(data.transferFrom);
    this.transferTo = new SecurityTransactionTo(data.transferTo);
    this.securityHoldersTo = data.securityHoldersTo?.map(holder => {
      switch (holder.$type) {
        case 'IndividualHolderModel':
          return new IndividualHolderModel(holder);
        case 'CorporateHolderModel':
          return new CorporateHolderModel(holder);
        default:
          throw new Error(`Unknown holder type: ${ holder.$type }`);
      }
    }) ?? [];
  }
}


export class SecurityTransactionFrom extends SecurityTransaction {
}

export class SecurityTransactionTo extends SecurityTransaction {
}
